import React from "react";
import { Alert, AlertTitle, Typography, alpha } from "@mui/material";

const AuthFeedback = ({ feedback, children, sx = {} }) =>
  feedback ? (
    <Alert
      severity={feedback.severity}
      variant='outlined'
      role={feedback.severity === "error" ? "alert" : "status"}
      aria-atomic='true'
      sx={[
        {
          p: 1.5,
          borderRadius: 2,
          borderColor: (theme) =>
            alpha(theme.palette[feedback.severity].main, 0.25),
          bgcolor: (theme) =>
            alpha(theme.palette[feedback.severity].main, 0.04),
          color: "text.primary",
          alignItems: "flex-start",
          overflowWrap: "anywhere",
          "& .MuiAlert-message": { minWidth: 0, py: 0, width: "100%" },
          "& .MuiAlert-icon": { pt: 0.25, mr: 1.25 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <AlertTitle sx={{ m: 0, mb: 0.5, fontSize: 14, fontWeight: 600 }}>
        {feedback.title}
      </AlertTitle>
      <Typography
        variant='body2'
        color='text.secondary'
        sx={{ lineHeight: 1.6 }}
      >
        {feedback.message}
      </Typography>
      {children}
    </Alert>
  ) : null;

export default AuthFeedback;
